import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "sg-portal-header" }
const _hoisted_2 = { class: "sg-portal-user" }
const _hoisted_3 = { class: "sg-portal-avatar" }
const _hoisted_4 = { class: "sg-portal-username" }
const _hoisted_5 = { class: "sg-portal-role" }
const _hoisted_6 = { class: "sg-portal-balance" }
const _hoisted_7 = { class: "sg-portal-balance-value" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "sg-portal-balance-label" }, "积分余额", -1 /* HOISTED */)
const _hoisted_9 = { class: "sg-stats" }
const _hoisted_10 = { class: "sg-stat-card" }
const _hoisted_11 = { class: "sg-stat-value" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "sg-stat-label" }, "我的建议", -1 /* HOISTED */)
const _hoisted_13 = { class: "sg-stat-card" }
const _hoisted_14 = { class: "sg-stat-value" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "sg-stat-label" }, "待评审", -1 /* HOISTED */)
const _hoisted_16 = { class: "sg-stat-card" }
const _hoisted_17 = { class: "sg-stat-value" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "sg-stat-label" }, "总获得", -1 /* HOISTED */)
const _hoisted_19 = { class: "sg-portal-tabs" }
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<svg width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\"><path d=\"M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z\"></path><polyline points=\"14 2 14 8 20 8\"></polyline><line x1=\"16\" y1=\"13\" x2=\"8\" y2=\"13\"></line><line x1=\"16\" y1=\"17\" x2=\"8\" y2=\"17\"></line></svg><span>我的建议</span>", 2)
const _hoisted_22 = [
  _hoisted_20
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  })
], -1 /* HOISTED */)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "评审", -1 /* HOISTED */)
const _hoisted_25 = {
  key: 0,
  class: "sg-tab-badge sg-badge-danger",
  style: {"position":"absolute","top":"-2px","right":"-4px"}
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12 15l-2 5-3-1 1-5.5-3.5-2 1-3.5L6 5l3-2 3 2 3-2 3 2-1 3.5 1.5 3.5-3.5 2 1 5.5-3 1z" })
], -1 /* HOISTED */)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, "排行榜", -1 /* HOISTED */)
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<svg width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\"><polyline points=\"20 12 20 22 4 22 4 12\"></polyline><rect x=\"2\" y=\"7\" width=\"20\" height=\"5\"></rect><line x1=\"12\" y1=\"22\" x2=\"12\" y2=\"7\"></line><path d=\"M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7z\"></path><path d=\"M12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z\"></path></svg><span>兑换</span>", 2)
const _hoisted_31 = [
  _hoisted_29
]
const _hoisted_32 = { class: "sg-portal-content" }
const _hoisted_33 = { class: "sg-sub-tabs" }
const _hoisted_34 = {
  key: 0,
  class: "sg-loading"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "sg-spinner" }, null, -1 /* HOISTED */)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", null, "加载中...", -1 /* HOISTED */)
const _hoisted_37 = [
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = {
  key: 0,
  class: "sg-empty"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "sg-empty-icon" }, "📝", -1 /* HOISTED */)
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { style: {"display":"flex","justify-content":"space-between","align-items":"flex-start","margin-bottom":"8px"} }
const _hoisted_42 = { style: {"font-size":"15px","font-weight":"500","color":"var(--text-1)","flex":"1"} }
const _hoisted_43 = { style: {"margin-bottom":"6px"} }
const _hoisted_44 = {
  class: "sg-category-tag active",
  style: {"cursor":"default"}
}
const _hoisted_45 = { style: {"display":"flex","justify-content":"space-between","font-size":"12px","color":"var(--text-3)"} }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = {
  key: 0,
  class: "sg-empty"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "sg-empty-icon" }, "💰", -1 /* HOISTED */)
const _hoisted_49 = { class: "sg-point-log-info" }
const _hoisted_50 = { class: "sg-point-log-type" }
const _hoisted_51 = {
  key: 0,
  class: "sg-point-log-remark"
}
const _hoisted_52 = { class: "sg-point-log-time" }
const _hoisted_53 = {
  key: 0,
  class: "sg-empty"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "sg-empty-icon" }, "🎁", -1 /* HOISTED */)
const _hoisted_55 = { style: {"display":"flex","justify-content":"space-between","align-items":"flex-start","margin-bottom":"8px"} }
const _hoisted_56 = { style: {"font-size":"15px","font-weight":"500","color":"var(--text-1)"} }
const _hoisted_57 = { style: {"display":"flex","justify-content":"space-between","font-size":"13px","color":"var(--text-2)"} }
const _hoisted_58 = { style: {"color":"var(--warning)","font-weight":"500"} }
const _hoisted_59 = {
  key: 0,
  style: {"font-size":"12px","color":"var(--text-3)","margin-top":"4px"}
}
const _hoisted_60 = { class: "sg-sub-tabs" }
const _hoisted_61 = {
  key: 0,
  class: "sg-tab-badge sg-badge-danger",
  style: {"margin-left":"4px"}
}
const _hoisted_62 = {
  key: 0,
  class: "sg-tab-badge sg-badge-success",
  style: {"margin-left":"4px"}
}
const _hoisted_63 = {
  key: 0,
  class: "sg-tab-badge sg-badge-muted",
  style: {"margin-left":"4px"}
}
const _hoisted_64 = {
  key: 0,
  class: "sg-loading"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "sg-spinner" }, null, -1 /* HOISTED */)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("p", null, "加载中...", -1 /* HOISTED */)
const _hoisted_67 = [
  _hoisted_65,
  _hoisted_66
]
const _hoisted_68 = { key: 1 }
const _hoisted_69 = {
  key: 0,
  class: "sg-empty"
}
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "sg-empty-icon" }, "📋", -1 /* HOISTED */)
const _hoisted_71 = ["onClick"]
const _hoisted_72 = { style: {"display":"flex","justify-content":"space-between","align-items":"flex-start"} }
const _hoisted_73 = { style: {"flex":"1","min-width":"0"} }
const _hoisted_74 = { style: {"font-size":"16px","font-weight":"600","color":"var(--text-1)","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_75 = { style: {"display":"flex","align-items":"center","margin-top":"6px","gap":"8px"} }
const _hoisted_76 = { class: "sg-badge sg-badge-purple" }
const _hoisted_77 = { style: {"font-size":"12px","color":"var(--text-3)"} }
const _hoisted_78 = { style: {"text-align":"right","flex-shrink":"0","margin-left":"12px","display":"flex","flex-direction":"column","align-items":"flex-end","gap":"4px"} }
const _hoisted_79 = {
  key: 0,
  style: {"font-size":"20px","font-weight":"700","color":"var(--primary)"}
}
const _hoisted_80 = {
  key: 2,
  style: {"font-size":"12px","color":"var(--warning)","font-weight":"500"}
}
const _hoisted_81 = ["onClick"]
const _hoisted_82 = { class: "sg-sub-tabs" }
const _hoisted_83 = { class: "sg-lb-my-stats" }
const _hoisted_84 = {
  key: 0,
  class: "sg-loading"
}
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "sg-spinner" }, null, -1 /* HOISTED */)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("p", null, "加载中...", -1 /* HOISTED */)
const _hoisted_87 = [
  _hoisted_85,
  _hoisted_86
]
const _hoisted_88 = {
  key: 0,
  class: "sg-empty"
}
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", { class: "sg-empty-icon" }, "🏆", -1 /* HOISTED */)
const _hoisted_90 = ["src", "alt"]
const _hoisted_91 = {
  key: 1,
  class: "sg-rank-avatar",
  style: {"background":"var(--primary)","color":"#fff","display":"flex","align-items":"center","justify-content":"center","font-weight":"bold"}
}
const _hoisted_92 = { class: "sg-rank-info" }
const _hoisted_93 = { class: "sg-rank-name" }
const _hoisted_94 = {
  key: 0,
  class: "sg-rank-dept"
}
const _hoisted_95 = { class: "sg-rank-points" }
const _hoisted_96 = { class: "sg-sub-tabs" }
const _hoisted_97 = {
  key: 0,
  class: "sg-loading"
}
const _hoisted_98 = /*#__PURE__*/_createElementVNode("div", { class: "sg-spinner" }, null, -1 /* HOISTED */)
const _hoisted_99 = /*#__PURE__*/_createElementVNode("p", null, "加载中...", -1 /* HOISTED */)
const _hoisted_100 = [
  _hoisted_98,
  _hoisted_99
]
const _hoisted_101 = {
  key: 0,
  class: "sg-empty"
}
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "sg-empty-icon" }, "📦", -1 /* HOISTED */)
const _hoisted_103 = {
  key: 1,
  class: "sg-items"
}
const _hoisted_104 = ["src"]
const _hoisted_105 = {
  key: 1,
  class: "sg-item-img",
  style: {"display":"flex","align-items":"center","justify-content":"center","font-size":"48px"}
}
const _hoisted_106 = { class: "sg-item-body" }
const _hoisted_107 = { class: "sg-item-name" }
const _hoisted_108 = {
  key: 0,
  class: "sg-item-desc"
}
const _hoisted_109 = { class: "sg-item-footer" }
const _hoisted_110 = { class: "sg-item-points" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"12px","color":"var(--text-3)"} }, " 积分", -1 /* HOISTED */)
const _hoisted_112 = {
  key: 0,
  class: "sg-item-stock",
  style: {"margin-left":"8px"}
}
const _hoisted_113 = {
  key: 1,
  class: "sg-item-stock",
  style: {"margin-left":"8px"}
}
const _hoisted_114 = ["disabled", "onClick"]
const _hoisted_115 = {
  key: 0,
  class: "sg-empty"
}
const _hoisted_116 = /*#__PURE__*/_createElementVNode("div", { class: "sg-empty-icon" }, "📋", -1 /* HOISTED */)
const _hoisted_117 = {
  key: 1,
  style: {"padding":"0 0 16px"}
}
const _hoisted_118 = { style: {"display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_119 = { style: {"font-size":"15px","font-weight":"500","color":"var(--text-1)"} }
const _hoisted_120 = { style: {"font-size":"12px","color":"var(--text-3)","margin-top":"4px"} }
const _hoisted_121 = { style: {"text-align":"right"} }
const _hoisted_122 = { style: {"font-size":"16px","font-weight":"bold","color":"var(--warning)"} }
const _hoisted_123 = ["onClick"]
const _hoisted_124 = { class: "sg-modal" }
const _hoisted_125 = /*#__PURE__*/_createElementVNode("span", { class: "sg-modal-title" }, "评审建议", -1 /* HOISTED */)
const _hoisted_126 = {
  key: 0,
  class: "sg-loading",
  style: {"padding":"40px 0"}
}
const _hoisted_127 = /*#__PURE__*/_createElementVNode("div", { class: "sg-spinner" }, null, -1 /* HOISTED */)
const _hoisted_128 = [
  _hoisted_127
]
const _hoisted_129 = {
  key: 1,
  class: "sg-modal-body"
}
const _hoisted_130 = { class: "sg-review-suggestion-info" }
const _hoisted_131 = { style: {"font-size":"18px","font-weight":"700","color":"var(--text-1)","line-height":"1.4"} }
const _hoisted_132 = { style: {"display":"flex","gap":"8px","margin-top":"8px","flex-wrap":"wrap"} }
const _hoisted_133 = { class: "sg-badge sg-badge-purple" }
const _hoisted_134 = { style: {"font-size":"12px","color":"var(--text-3)"} }
const _hoisted_135 = ["innerHTML"]
const _hoisted_136 = {
  key: 1,
  style: {"margin-top":"12px"}
}
const _hoisted_137 = /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"13px","font-weight":"500","color":"var(--text-2)","margin-bottom":"8px"} }, "附件图片", -1 /* HOISTED */)
const _hoisted_138 = { class: "sg-image-list" }
const _hoisted_139 = ["onClick"]
const _hoisted_140 = ["src"]
const _hoisted_141 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"1px","background":"var(--border)","margin":"20px 0"} }, null, -1 /* HOISTED */)
const _hoisted_142 = { key: 0 }
const _hoisted_143 = /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"15px","font-weight":"600","color":"var(--text-1)","margin-bottom":"16px"} }, "维度打分", -1 /* HOISTED */)
const _hoisted_144 = { style: {"display":"flex","justify-content":"space-between","align-items":"center","margin-bottom":"8px"} }
const _hoisted_145 = { style: {"font-size":"14px","font-weight":"500","color":"var(--text-1)"} }
const _hoisted_146 = { style: {"font-size":"12px","color":"var(--text-3)","margin-left":"4px"} }
const _hoisted_147 = { style: {"font-size":"16px","font-weight":"700","color":"var(--primary)"} }
const _hoisted_148 = { style: {"font-size":"12px","color":"var(--text-3)","font-weight":"400"} }
const _hoisted_149 = {
  key: 0,
  style: {"font-size":"12px","color":"var(--text-3)","margin-bottom":"6px"}
}
const _hoisted_150 = { class: "sg-score-slider-wrap" }
const _hoisted_151 = ["max", "value", "onInput"]
const _hoisted_152 = { class: "sg-score-labels" }
const _hoisted_153 = /*#__PURE__*/_createElementVNode("span", null, "0", -1 /* HOISTED */)
const _hoisted_154 = { style: {"margin-top":"20px"} }
const _hoisted_155 = /*#__PURE__*/_createElementVNode("div", { class: "sg-form-label" }, "评审意见", -1 /* HOISTED */)
const _hoisted_156 = { style: {"margin-top":"16px"} }
const _hoisted_157 = /*#__PURE__*/_createElementVNode("div", { class: "sg-form-label" }, "综合建议", -1 /* HOISTED */)
const _hoisted_158 = { class: "sg-rec-options" }
const _hoisted_159 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"20px"} }, "✓", -1 /* HOISTED */)
const _hoisted_160 = /*#__PURE__*/_createElementVNode("span", null, "建议采纳", -1 /* HOISTED */)
const _hoisted_161 = [
  _hoisted_159,
  _hoisted_160
]
const _hoisted_162 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"20px"} }, "?", -1 /* HOISTED */)
const _hoisted_163 = /*#__PURE__*/_createElementVNode("span", null, "待定", -1 /* HOISTED */)
const _hoisted_164 = [
  _hoisted_162,
  _hoisted_163
]
const _hoisted_165 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"20px"} }, "✗", -1 /* HOISTED */)
const _hoisted_166 = /*#__PURE__*/_createElementVNode("span", null, "建议拒绝", -1 /* HOISTED */)
const _hoisted_167 = [
  _hoisted_165,
  _hoisted_166
]
const _hoisted_168 = { style: {"margin-top":"24px","display":"flex","gap":"10px"} }
const _hoisted_169 = ["disabled"]
const _hoisted_170 = /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"15px","font-weight":"600","color":"var(--text-1)","margin-bottom":"16px"} }, "评审结果", -1 /* HOISTED */)
const _hoisted_171 = { style: {"display":"flex","justify-content":"space-between","align-items":"center","margin-bottom":"6px"} }
const _hoisted_172 = { style: {"font-size":"14px","color":"var(--text-1)"} }
const _hoisted_173 = { style: {"font-size":"16px","font-weight":"700","color":"var(--primary)"} }
const _hoisted_174 = { style: {"font-size":"12px","color":"var(--text-3)"} }
const _hoisted_175 = { style: {"font-size":"12px","color":"var(--text-3)","margin-left":"6px"} }
const _hoisted_176 = { class: "sg-score-bar-bg" }
const _hoisted_177 = { style: {"margin-top":"16px","padding":"14px","background":"var(--primary-light)","border-radius":"var(--radius-md)","text-align":"center"} }
const _hoisted_178 = /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"13px","color":"var(--text-3)"} }, "加权总分", -1 /* HOISTED */)
const _hoisted_179 = { style: {"font-size":"28px","font-weight":"700","color":"var(--primary)"} }
const _hoisted_180 = {
  key: 0,
  style: {"margin-top":"14px","font-size":"14px","color":"var(--text-2)","line-height":"1.6","background":"var(--bg-2)","padding":"14px","border-radius":"var(--radius-md)"}
}
const _hoisted_181 = /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"12px","font-weight":"500","color":"var(--text-3)","margin-bottom":"4px"} }, "评审意见", -1 /* HOISTED */)
const _hoisted_182 = {
  key: 1,
  style: {"margin-top":"10px","text-align":"center"}
}
const _hoisted_183 = ["onClick"]
const _hoisted_184 = { class: "sg-modal" }
const _hoisted_185 = /*#__PURE__*/_createElementVNode("span", { class: "sg-modal-title" }, "建议详情", -1 /* HOISTED */)
const _hoisted_186 = {
  key: 0,
  class: "sg-loading",
  style: {"padding":"40px 0"}
}
const _hoisted_187 = /*#__PURE__*/_createElementVNode("div", { class: "sg-spinner" }, null, -1 /* HOISTED */)
const _hoisted_188 = [
  _hoisted_187
]
const _hoisted_189 = {
  key: 1,
  class: "sg-modal-body"
}
const _hoisted_190 = { style: {"font-size":"18px","font-weight":"700","color":"var(--text-1)","line-height":"1.4"} }
const _hoisted_191 = { style: {"display":"flex","gap":"8px","margin-top":"8px","flex-wrap":"wrap"} }
const _hoisted_192 = { class: "sg-badge sg-badge-purple" }
const _hoisted_193 = ["innerHTML"]
const _hoisted_194 = {
  key: 1,
  style: {"margin-top":"12px"}
}
const _hoisted_195 = /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"13px","font-weight":"500","color":"var(--text-2)","margin-bottom":"8px"} }, "附件图片", -1 /* HOISTED */)
const _hoisted_196 = { class: "sg-image-list" }
const _hoisted_197 = ["onClick"]
const _hoisted_198 = ["src"]
const _hoisted_199 = {
  key: 2,
  style: {"margin-top":"16px","padding":"14px","background":"var(--primary-light)","border-radius":"var(--radius-md)","text-align":"center"}
}
const _hoisted_200 = /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"13px","color":"var(--text-3)"} }, "综合得分", -1 /* HOISTED */)
const _hoisted_201 = { style: {"font-size":"28px","font-weight":"700","color":"var(--primary)"} }
const _hoisted_202 = { style: {"margin-top":"16px","font-size":"12px","color":"var(--text-3)"} }
const _hoisted_203 = ["src"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createCommentVNode(" 顶部用户信息 "),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString($setup.userInitial), 1 /* TEXT */),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, _toDisplayString($setup.userName), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_5, _toDisplayString($setup.roleLabel), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString($setup.myStats.balance || 0), 1 /* TEXT */),
        _hoisted_8
      ])
    ]),
    _createCommentVNode(" 统计概览 "),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, _toDisplayString($setup.myStats.suggestion_count || 0), 1 /* TEXT */),
        _hoisted_12
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, _toDisplayString($setup.reviewStats.pending || 0), 1 /* TEXT */),
        _hoisted_15
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, _toDisplayString($setup.myStats.total_earned || 0), 1 /* TEXT */),
        _hoisted_18
      ])
    ]),
    _createCommentVNode(" 底部 Tab 导航 "),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", {
        class: _normalizeClass(["sg-portal-tab", { active: $setup.mainTab === 'suggestions' }]),
        onClick: _cache[0] || (_cache[0] = $event => ($setup.switchMainTab('suggestions')))
      }, _hoisted_22, 2 /* CLASS */),
      _createElementVNode("div", {
        class: _normalizeClass(["sg-portal-tab", { active: $setup.mainTab === 'review' }]),
        onClick: _cache[1] || (_cache[1] = $event => ($setup.switchMainTab('review')))
      }, [
        _hoisted_23,
        _hoisted_24,
        ($setup.reviewStats.pending > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString($setup.reviewStats.pending), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */),
      _createElementVNode("div", {
        class: _normalizeClass(["sg-portal-tab", { active: $setup.mainTab === 'leaderboard' }]),
        onClick: _cache[2] || (_cache[2] = $event => ($setup.switchMainTab('leaderboard')))
      }, _hoisted_28, 2 /* CLASS */),
      _createElementVNode("div", {
        class: _normalizeClass(["sg-portal-tab", { active: $setup.mainTab === 'redemption' }]),
        onClick: _cache[3] || (_cache[3] = $event => ($setup.switchMainTab('redemption')))
      }, _hoisted_31, 2 /* CLASS */)
    ]),
    _createCommentVNode(" 内容区 "),
    _createElementVNode("div", _hoisted_32, [
      _createCommentVNode(" ===== 我的建议 ===== "),
      ($setup.mainTab === 'suggestions')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", {
                class: _normalizeClass(["sg-sub-tab", { active: $setup.subTab === 'my_suggestions' }]),
                onClick: _cache[4] || (_cache[4] = $event => ($setup.switchSubTab('my_suggestions')))
              }, "我的建议", 2 /* CLASS */),
              _createElementVNode("div", {
                class: _normalizeClass(["sg-sub-tab", { active: $setup.subTab === 'points' }]),
                onClick: _cache[5] || (_cache[5] = $event => ($setup.switchSubTab('points')))
              }, "积分明细", 2 /* CLASS */),
              _createElementVNode("div", {
                class: _normalizeClass(["sg-sub-tab", { active: $setup.subTab === 'my_redemptions' }]),
                onClick: _cache[6] || (_cache[6] = $event => ($setup.switchSubTab('my_redemptions')))
              }, "兑换记录", 2 /* CLASS */)
            ]),
            ($setup.contentLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_37))
              : ($setup.subTab === 'my_suggestions')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (!$setup.suggestions.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _hoisted_39,
                          _createTextVNode("暂无建议记录")
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.suggestions, (s) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: s.name,
                        class: "sg-card",
                        onClick: $event => ($setup.openSuggestionDetail(s)),
                        style: {"cursor":"pointer"}
                      }, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, _toDisplayString(s.title), 1 /* TEXT */),
                          _createElementVNode("span", {
                            class: "sg-status-pill",
                            style: _normalizeStyle($setup.getStatusStyle(s.status))
                          }, _toDisplayString($setup.getStatusText(s.status)), 5 /* TEXT, STYLE */)
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("span", _hoisted_44, _toDisplayString(s.category), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("span", null, _toDisplayString($setup.formatDate(s.creation)), 1 /* TEXT */),
                          (s.total_score != null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_46, "得分：" + _toDisplayString(s.total_score), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ])
                      ], 8 /* PROPS */, _hoisted_40))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 64 /* STABLE_FRAGMENT */))
                : ($setup.subTab === 'points')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (!$setup.pointLogs.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                            _hoisted_48,
                            _createTextVNode("暂无积分记录")
                          ]))
                        : _createCommentVNode("v-if", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pointLogs, (log) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: log.name,
                          class: "sg-point-log"
                        }, [
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("div", _hoisted_50, _toDisplayString(log.point_type), 1 /* TEXT */),
                            (log.remark)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(log.remark), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true),
                            _createElementVNode("div", _hoisted_52, _toDisplayString($setup.formatDate(log.creation)), 1 /* TEXT */)
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["sg-point-log-value", log.points >= 0 ? 'plus' : 'minus'])
                          }, _toDisplayString(log.points >= 0 ? '+' : '') + _toDisplayString(log.points), 3 /* TEXT, CLASS */)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 64 /* STABLE_FRAGMENT */))
                  : ($setup.subTab === 'my_redemptions')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        (!$setup.myRedemptions.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                              _hoisted_54,
                              _createTextVNode("暂无兑换记录")
                            ]))
                          : _createCommentVNode("v-if", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.myRedemptions, (r) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: r.name,
                            class: "sg-card"
                          }, [
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("div", _hoisted_56, _toDisplayString(r.item_name), 1 /* TEXT */),
                              _createElementVNode("span", {
                                class: "sg-status-pill",
                                style: _normalizeStyle($setup.getStatusStyle(r.status))
                              }, _toDisplayString($setup.getStatusText(r.status)), 5 /* TEXT, STYLE */)
                            ]),
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("span", null, "数量：" + _toDisplayString(r.quantity), 1 /* TEXT */),
                              _createElementVNode("span", _hoisted_58, "-" + _toDisplayString(r.points_cost) + " 积分", 1 /* TEXT */)
                            ]),
                            (r.redemption_date)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString($setup.formatDate(r.redemption_date)), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" ===== 评审 ===== "),
      ($setup.mainTab === 'review')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", {
                class: _normalizeClass(["sg-sub-tab", { active: $setup.reviewTab === 'pending' }]),
                onClick: _cache[7] || (_cache[7] = $event => ($setup.switchReviewTab('pending')))
              }, [
                _createTextVNode(" 待评审"),
                ($setup.reviewStats.pending > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString($setup.reviewStats.pending), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ], 2 /* CLASS */),
              _createElementVNode("div", {
                class: _normalizeClass(["sg-sub-tab", { active: $setup.reviewTab === 'completed' }]),
                onClick: _cache[8] || (_cache[8] = $event => ($setup.switchReviewTab('completed')))
              }, [
                _createTextVNode(" 已评审"),
                ($setup.reviewStats.completed > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString($setup.reviewStats.completed), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ], 2 /* CLASS */),
              _createElementVNode("div", {
                class: _normalizeClass(["sg-sub-tab", { active: $setup.reviewTab === 'skipped' }]),
                onClick: _cache[9] || (_cache[9] = $event => ($setup.switchReviewTab('skipped')))
              }, [
                _createTextVNode(" 已跳过"),
                ($setup.reviewStats.skipped > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_63, _toDisplayString($setup.reviewStats.skipped), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ], 2 /* CLASS */)
            ]),
            ($setup.contentLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_64, _hoisted_67))
              : (_openBlock(), _createElementBlock("div", _hoisted_68, [
                  (!$setup.reviews.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                        _hoisted_70,
                        _createTextVNode(_toDisplayString($setup.reviewEmptyText), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.reviews, (r) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: r.name,
                      class: "sg-card",
                      style: {"cursor":"pointer"},
                      onClick: $event => ($setup.openReview(r))
                    }, [
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("div", _hoisted_73, [
                          _createElementVNode("div", _hoisted_74, _toDisplayString(r.suggestion_title), 1 /* TEXT */),
                          _createElementVNode("div", _hoisted_75, [
                            _createElementVNode("span", _hoisted_76, _toDisplayString(r.suggestion_category), 1 /* TEXT */),
                            _createElementVNode("span", _hoisted_77, _toDisplayString($setup.formatDate(r.creation)), 1 /* TEXT */)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_78, [
                          (r.total_score != null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_79, _toDisplayString(r.total_score.toFixed(1)), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          (r.recommendation)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                style: _normalizeStyle([{"font-size":"12px"}, $setup.getRecStyle(r.recommendation)])
                              }, _toDisplayString(r.recommendation), 5 /* TEXT, STYLE */))
                            : _createCommentVNode("v-if", true),
                          (r.status === '待评审')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_80, "待评审 >"))
                            : _createCommentVNode("v-if", true),
                          (r.status === '已跳过')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 3,
                                class: "sg-btn-unskip",
                                onClick: _withModifiers($event => ($setup.unskipReview(r)), ["stop"])
                              }, "撤销跳过", 8 /* PROPS */, _hoisted_81))
                            : _createCommentVNode("v-if", true)
                        ])
                      ])
                    ], 8 /* PROPS */, _hoisted_71))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" ===== 排行榜 ===== "),
      ($setup.mainTab === 'leaderboard')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_82, [
              _createElementVNode("div", {
                class: _normalizeClass(["sg-sub-tab", { active: $setup.lbTab === 'monthly' }]),
                onClick: _cache[10] || (_cache[10] = $event => ($setup.switchLbTab('monthly')))
              }, "月度", 2 /* CLASS */),
              _createElementVNode("div", {
                class: _normalizeClass(["sg-sub-tab", { active: $setup.lbTab === 'yearly' }]),
                onClick: _cache[11] || (_cache[11] = $event => ($setup.switchLbTab('yearly')))
              }, "年度", 2 /* CLASS */),
              _createElementVNode("div", {
                class: _normalizeClass(["sg-sub-tab", { active: $setup.lbTab === 'all' }]),
                onClick: _cache[12] || (_cache[12] = $event => ($setup.switchLbTab('all')))
              }, "总排行", 2 /* CLASS */)
            ]),
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("span", null, [
                _createTextVNode("本月获得 "),
                _createElementVNode("strong", null, _toDisplayString($setup.myStats.monthly_earned || 0), 1 /* TEXT */)
              ]),
              _createElementVNode("span", null, [
                _createTextVNode("总获得 "),
                _createElementVNode("strong", null, _toDisplayString($setup.myStats.total_earned || 0), 1 /* TEXT */)
              ])
            ]),
            ($setup.contentLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_84, _hoisted_87))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (!$setup.leaderboard.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                        _hoisted_89,
                        _createTextVNode("暂无排行数据")
                      ]))
                    : _createCommentVNode("v-if", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.leaderboard, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.user,
                      class: "sg-rank-item"
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["sg-rank-num", $setup.getRankClass(item.rank)])
                      }, _toDisplayString(item.rank), 3 /* TEXT, CLASS */),
                      (item.user_image)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "sg-rank-avatar",
                            src: item.user_image,
                            alt: item.full_name
                          }, null, 8 /* PROPS */, _hoisted_90))
                        : (_openBlock(), _createElementBlock("div", _hoisted_91, _toDisplayString((item.full_name || item.user || '?').charAt(0)), 1 /* TEXT */)),
                      _createElementVNode("div", _hoisted_92, [
                        _createElementVNode("div", _hoisted_93, _toDisplayString(item.full_name || item.user), 1 /* TEXT */),
                        (item.department)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_94, _toDisplayString(item.department), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("div", _hoisted_95, _toDisplayString(item.total_points || 0), 1 /* TEXT */)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 64 /* STABLE_FRAGMENT */))
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" ===== 积分兑换 ===== "),
      ($setup.mainTab === 'redemption')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createElementVNode("div", _hoisted_96, [
              _createElementVNode("div", {
                class: _normalizeClass(["sg-sub-tab", { active: $setup.redTab === 'shop' }]),
                onClick: _cache[13] || (_cache[13] = $event => ($setup.switchRedTab('shop')))
              }, "可兑换", 2 /* CLASS */),
              _createElementVNode("div", {
                class: _normalizeClass(["sg-sub-tab", { active: $setup.redTab === 'mine' }]),
                onClick: _cache[14] || (_cache[14] = $event => ($setup.switchRedTab('mine')))
              }, "我的兑换", 2 /* CLASS */)
            ]),
            ($setup.contentLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_97, _hoisted_100))
              : ($setup.redTab === 'shop')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (!$setup.redemptionItems.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                          _hoisted_102,
                          _createTextVNode("暂无可兑换商品")
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_103, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.redemptionItems, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.name,
                              class: "sg-item-card"
                            }, [
                              (item.image)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: item.image,
                                    class: "sg-item-img"
                                  }, null, 8 /* PROPS */, _hoisted_104))
                                : (_openBlock(), _createElementBlock("div", _hoisted_105, "🎁")),
                              _createElementVNode("div", _hoisted_106, [
                                _createElementVNode("div", _hoisted_107, _toDisplayString(item.item_name), 1 /* TEXT */),
                                (item.description)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_108, _toDisplayString(item.description), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true),
                                _createElementVNode("div", _hoisted_109, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("span", _hoisted_110, _toDisplayString(item.points_required), 1 /* TEXT */),
                                    _hoisted_111,
                                    (item.stock > 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_112, "库存: " + _toDisplayString(item.stock), 1 /* TEXT */))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_113, "不限"))
                                  ]),
                                  _createElementVNode("button", {
                                    class: "sg-btn sg-btn-primary",
                                    style: {"width":"auto","padding":"6px 16px","font-size":"13px"},
                                    disabled: $setup.redeeming === item.name || ($setup.myStats.balance || 0) < item.points_required,
                                    onClick: $event => ($setup.handleRedeem(item))
                                  }, _toDisplayString($setup.redeeming === item.name ? '兑换中...' : '兑换'), 9 /* TEXT, PROPS */, _hoisted_114)
                                ])
                              ])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                  ], 64 /* STABLE_FRAGMENT */))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (!$setup.myRedemptions.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                          _hoisted_116,
                          _createTextVNode("暂无兑换记录")
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_117, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.myRedemptions, (r) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: r.name,
                              class: "sg-card",
                              style: {"margin-bottom":"8px"}
                            }, [
                              _createElementVNode("div", _hoisted_118, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_119, _toDisplayString(r.item_name), 1 /* TEXT */),
                                  _createElementVNode("div", _hoisted_120, _toDisplayString($setup.formatDate(r.redemption_date)) + " · x" + _toDisplayString(r.quantity), 1 /* TEXT */)
                                ]),
                                _createElementVNode("div", _hoisted_121, [
                                  _createElementVNode("div", _hoisted_122, "-" + _toDisplayString(r.points_cost), 1 /* TEXT */),
                                  _createElementVNode("span", {
                                    class: "sg-status-pill",
                                    style: _normalizeStyle($setup.getStatusStyle(r.status))
                                  }, _toDisplayString($setup.getStatusText(r.status)), 5 /* TEXT, STYLE */)
                                ])
                              ])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                  ], 64 /* STABLE_FRAGMENT */))
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true)
    ]),
    _createCommentVNode(" ===== 评审弹窗 ===== "),
    ($setup.showReviewModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "sg-modal-overlay",
          onClick: _withModifiers($setup.closeReviewModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_124, [
            _createElementVNode("div", { class: "sg-modal-header" }, [
              _hoisted_125,
              _createElementVNode("span", {
                class: "sg-modal-close",
                onClick: $setup.closeReviewModal
              }, "×")
            ]),
            ($setup.modalLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_126, _hoisted_128))
              : (_openBlock(), _createElementBlock("div", _hoisted_129, [
                  _createCommentVNode(" 建议信息 "),
                  _createElementVNode("div", _hoisted_130, [
                    _createElementVNode("div", _hoisted_131, _toDisplayString($setup.reviewDetail.suggestion.title), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_132, [
                      _createElementVNode("span", _hoisted_133, _toDisplayString($setup.reviewDetail.suggestion.category), 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_134, "建议人: " + _toDisplayString($setup.reviewDetail.suggestion.submitted_by), 1 /* TEXT */)
                    ]),
                    ($setup.reviewDetail.suggestion.description)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          style: {"margin-top":"12px","font-size":"14px","color":"var(--text-2)","line-height":"1.6","background":"var(--bg-2)","padding":"14px","border-radius":"var(--radius-md)"},
                          innerHTML: $setup.reviewDetail.suggestion.description
                        }, null, 8 /* PROPS */, _hoisted_135))
                      : _createCommentVNode("v-if", true),
                    ($setup.reviewDetail.attachments && $setup.reviewDetail.attachments.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                          _hoisted_137,
                          _createElementVNode("div", _hoisted_138, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.reviewDetail.attachments, (att, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: i,
                                class: "sg-image-item",
                                style: {"width":"72px","height":"72px","cursor":"pointer"},
                                onClick: $event => ($setup.previewImage(att.file_url))
                              }, [
                                _createElementVNode("img", {
                                  src: att.file_url
                                }, null, 8 /* PROPS */, _hoisted_140)
                              ], 8 /* PROPS */, _hoisted_139))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _hoisted_141,
                  _createCommentVNode(" 打分 "),
                  ($setup.isReviewPending)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                        _hoisted_143,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dimensions, (dim) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: dim.name,
                            class: "sg-score-row"
                          }, [
                            _createElementVNode("div", _hoisted_144, [
                              _createElementVNode("div", null, [
                                _createElementVNode("span", _hoisted_145, _toDisplayString(dim.dimension_name), 1 /* TEXT */),
                                _createElementVNode("span", _hoisted_146, "(" + _toDisplayString(dim.weight) + "%)", 1 /* TEXT */)
                              ]),
                              _createElementVNode("div", _hoisted_147, [
                                _createTextVNode(_toDisplayString($setup.getScore(dim.name)), 1 /* TEXT */),
                                _createElementVNode("span", _hoisted_148, "/" + _toDisplayString(dim.max_score), 1 /* TEXT */)
                              ])
                            ]),
                            (dim.description)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_149, _toDisplayString(dim.description), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true),
                            _createElementVNode("div", _hoisted_150, [
                              _createElementVNode("input", {
                                type: "range",
                                class: "sg-score-slider",
                                min: 0,
                                max: dim.max_score,
                                step: 1,
                                value: $setup.getScore(dim.name),
                                onInput: $event => ($setup.setScore(dim.name, $event.target.value))
                              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_151),
                              _createElementVNode("div", _hoisted_152, [
                                _hoisted_153,
                                _createElementVNode("span", null, _toDisplayString(dim.max_score), 1 /* TEXT */)
                              ])
                            ])
                          ]))
                        }), 128 /* KEYED_FRAGMENT */)),
                        _createElementVNode("div", _hoisted_154, [
                          _hoisted_155,
                          _withDirectives(_createElementVNode("textarea", {
                            class: "sg-textarea",
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => (($setup.reviewComment) = $event)),
                            placeholder: "请输入您的评审意见...",
                            style: {"min-height":"100px"}
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelText, $setup.reviewComment]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_156, [
                          _hoisted_157,
                          _createElementVNode("div", _hoisted_158, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["sg-rec-option", { active: $setup.reviewRecommendation === '建议采纳' }]),
                              onClick: _cache[16] || (_cache[16] = $event => ($setup.reviewRecommendation = '建议采纳'))
                            }, _hoisted_161, 2 /* CLASS */),
                            _createElementVNode("div", {
                              class: _normalizeClass(["sg-rec-option", { active: $setup.reviewRecommendation === '待定' }]),
                              onClick: _cache[17] || (_cache[17] = $event => ($setup.reviewRecommendation = '待定'))
                            }, _hoisted_164, 2 /* CLASS */),
                            _createElementVNode("div", {
                              class: _normalizeClass(["sg-rec-option reject", { active: $setup.reviewRecommendation === '建议拒绝' }]),
                              onClick: _cache[18] || (_cache[18] = $event => ($setup.reviewRecommendation = '建议拒绝'))
                            }, _hoisted_167, 2 /* CLASS */)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_168, [
                          _createElementVNode("button", {
                            class: "sg-btn sg-btn-outline",
                            style: {"flex":"1"},
                            onClick: $setup.skipCurrentReview
                          }, "跳过"),
                          _createElementVNode("button", {
                            class: "sg-btn sg-btn-primary",
                            style: {"flex":"2"},
                            disabled: $setup.submitting,
                            onClick: $setup.submitCurrentReview
                          }, _toDisplayString($setup.submitting ? '提交中...' : '提交评审'), 9 /* TEXT, PROPS */, _hoisted_169)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createCommentVNode(" 已评审结果 "),
                        _createElementVNode("div", null, [
                          _hoisted_170,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.reviewDetail.review.scores, (row) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: row.name,
                              class: "sg-score-row"
                            }, [
                              _createElementVNode("div", _hoisted_171, [
                                _createElementVNode("span", _hoisted_172, _toDisplayString(row.dimension), 1 /* TEXT */),
                                _createElementVNode("div", null, [
                                  _createElementVNode("span", _hoisted_173, _toDisplayString(row.score), 1 /* TEXT */),
                                  _createElementVNode("span", _hoisted_174, "/" + _toDisplayString(row.max_score || 10), 1 /* TEXT */),
                                  _createElementVNode("span", _hoisted_175, "权重 " + _toDisplayString(row.weight) + "%", 1 /* TEXT */)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_176, [
                                _createElementVNode("div", {
                                  class: "sg-score-bar",
                                  style: _normalizeStyle({ width: (row.score / (row.max_score || 10) * 100) + '%' })
                                }, null, 4 /* STYLE */)
                              ])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */)),
                          _createElementVNode("div", _hoisted_177, [
                            _hoisted_178,
                            _createElementVNode("div", _hoisted_179, _toDisplayString(($setup.reviewDetail.review.total_score || 0).toFixed(2)), 1 /* TEXT */)
                          ]),
                          ($setup.reviewDetail.review.comment)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_180, [
                                _hoisted_181,
                                _createTextVNode(" " + _toDisplayString($setup.reviewDetail.review.comment), 1 /* TEXT */)
                              ]))
                            : _createCommentVNode("v-if", true),
                          ($setup.reviewDetail.review.recommendation)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_182, [
                                _createElementVNode("span", {
                                  class: "sg-badge",
                                  style: _normalizeStyle($setup.getRecStyle($setup.reviewDetail.review.recommendation))
                                }, _toDisplayString($setup.reviewDetail.review.recommendation), 5 /* TEXT, STYLE */)
                              ]))
                            : _createCommentVNode("v-if", true)
                        ])
                      ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                ]))
          ])
        ], 8 /* PROPS */, _hoisted_123))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" ===== 建议详情弹窗 ===== "),
    ($setup.showSuggestionModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "sg-modal-overlay",
          onClick: _withModifiers($setup.closeSuggestionModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_184, [
            _createElementVNode("div", { class: "sg-modal-header" }, [
              _hoisted_185,
              _createElementVNode("span", {
                class: "sg-modal-close",
                onClick: $setup.closeSuggestionModal
              }, "×")
            ]),
            ($setup.suggestionDetailLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_186, _hoisted_188))
              : (_openBlock(), _createElementBlock("div", _hoisted_189, [
                  _createElementVNode("div", _hoisted_190, _toDisplayString($setup.suggestionDetail.title), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_191, [
                    _createElementVNode("span", _hoisted_192, _toDisplayString($setup.suggestionDetail.category), 1 /* TEXT */),
                    _createElementVNode("span", {
                      class: "sg-status-pill",
                      style: _normalizeStyle($setup.getStatusStyle($setup.suggestionDetail.status))
                    }, _toDisplayString($setup.getStatusText($setup.suggestionDetail.status)), 5 /* TEXT, STYLE */)
                  ]),
                  ($setup.suggestionDetail.description)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        style: {"margin-top":"12px","font-size":"14px","color":"var(--text-2)","line-height":"1.6","background":"var(--bg-2)","padding":"14px","border-radius":"var(--radius-md)"},
                        innerHTML: $setup.suggestionDetail.description
                      }, null, 8 /* PROPS */, _hoisted_193))
                    : _createCommentVNode("v-if", true),
                  ($setup.suggestionAttachments && $setup.suggestionAttachments.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_194, [
                        _hoisted_195,
                        _createElementVNode("div", _hoisted_196, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.suggestionAttachments, (att, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: i,
                              class: "sg-image-item",
                              style: {"width":"72px","height":"72px","cursor":"pointer"},
                              onClick: $event => ($setup.previewImage(att.file_url))
                            }, [
                              _createElementVNode("img", {
                                src: att.file_url
                              }, null, 8 /* PROPS */, _hoisted_198)
                            ], 8 /* PROPS */, _hoisted_197))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  ($setup.suggestionDetail.total_score != null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_199, [
                        _hoisted_200,
                        _createElementVNode("div", _hoisted_201, _toDisplayString($setup.suggestionDetail.total_score), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_202, " 提交时间：" + _toDisplayString($setup.formatDate($setup.suggestionDetail.creation)), 1 /* TEXT */)
                ]))
          ])
        ], 8 /* PROPS */, _hoisted_183))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" 图片预览 "),
    ($setup.previewingImage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "sg-image-preview-overlay",
          onClick: _cache[20] || (_cache[20] = $event => ($setup.previewingImage = null))
        }, [
          _createElementVNode("img", {
            src: $setup.previewingImage,
            class: "sg-image-preview-img",
            onClick: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["stop"]))
          }, null, 8 /* PROPS */, _hoisted_203)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}